import {h} from 'preact';
import PropTypes from 'prop-types';

export default function FormItem({title, children, errorsClass}){
	return (
			<div className="form__item">
				<div className={`form-field form-field_gray ${errorsClass}`}>
					<div className="form-field__inner">
						<div className="form-field__title-row">
							<label className="form-field__title">{title}</label>
						</div>
						<div className="form-field__input-row">
							{children}
						</div>
					</div>
				</div>
			</div>
	)
}

FormItem.propTypes = {
	title: PropTypes.string.isRequired,
};